import {
  FormTextarea,
  ReadonlyField,
  type FormTextareaProps,
  type ReadonlyFieldProps,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import type { BaseInputModeProps, BaseViewModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormTextareaProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content'>>;

export type TextareaRendererProps = InputModeProps | ViewModeProps;

export default function TextareaRenderer(props: Readonly<TextareaRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;
      return <FormTextarea name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      return <ReadonlyField content={value} {...slotProps} />;
    }
  }
}
